import { EnumArchiveStatus } from 'api';
const archivedInvoiceStatuses = [EnumArchiveStatus.Verified, EnumArchiveStatus.Deleted, EnumArchiveStatus.FailedToDelete];
export default function isInvoiceArchived(invoice) {
  return !!invoice?.archiveDetails?.archiveStatus && archivedInvoiceStatuses.includes(invoice?.archiveDetails?.archiveStatus);
}